<template>
  <div class="financial-institution-editor">
    <label class="label">ชื่อ</label>
    <el-input
      :value="value.name"
      class="input"
      @input="handleChangeInput('name', $event)"
    ></el-input>
    <label class="label">ชื่อย่อ (ภาษาอังกฤษ)</label>
    <el-input
      :value="value.code"
      class="input"
      @input="handleChangeInput('code', $event)"
    ></el-input>
  </div>
</template>

<script>
import { Input } from "element-ui"

export default {
  components: {
    "el-input": Input,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
  },
  methods: {
    handleChangeInput(key, value) {
      this.$emit("input", { ...this.value, [key]: value })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;
}
</style>
